// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3eKqq","modalFooterButton":"ModalNotes_modalFooterButton__3NBsR"};